import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { HeaderDetails as FoundationsHeaderDetails } from 'foundations-components/transitional/components/Header';
import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import { getContentPropertyValue, CONTENT_PLATFORM_PROPERTY_NAME, contentHasTranslations, RequestStatuses } from 'content-management-data-lib';
import { View } from 'foundations-components/components/View';
import { useContentDetailsDataProvider } from '../../providers/ContentDetailsDataProvider';
import { useContentSettingsData } from '../../providers/ContentSettingsDataProvider';
import { ContentPreviewScreenshot } from '../ContentPreviewImage';
import LanguageTranslationSelector from '../LanguageTranslationSelector';
import { useLanguageVariationsProvider } from '../../providers/LanguageVariationsProvider';
import { useDetailsRenderConfig } from '../../providers/DetailsRenderConfigProvider';
import { HeaderDetailsRows } from './HeaderDetailRows';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeaderDetailsList = ({
  contentObject,
  onChangeLanguageVariation,
  openDetailsPanel
}) => {
  const {
    detailsHeaderConfig
  } = useDetailsRenderConfig();
  const {
    contentId
  } = useContentDetailsDataProvider();
  const {
    getBodyOverrideSettingByContentObjectDomain,
    requestStatus
  } = useContentSettingsData();
  const hasTranslatedContent = contentHasTranslations(contentObject);
  const language = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.LANGUAGE);
  const domainLanguage = getBodyOverrideSettingByContentObjectDomain(contentObject, 'contentLanguage');
  const shouldShowLanguage = !hasTranslatedContent && language && requestStatus === RequestStatuses.SUCCEEDED && language !== domainLanguage;
  return /*#__PURE__*/_jsx(View, {
    maxInlineSize: "33vw",
    children: /*#__PURE__*/_jsxs(DescriptionList, {
      children: [hasTranslatedContent && /*#__PURE__*/_jsx(LanguageTranslationSelector, {
        contentId: contentId,
        contentObject: contentObject,
        onChangeLanguageVariation: onChangeLanguageVariation
      }), shouldShowLanguage && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "content-management-details-lib.header.headerDetails.language",
        options: {
          language: I18n.text(`SharedI18nStrings.languageNames.${language || domainLanguage}`)
        }
      }), /*#__PURE__*/_jsx(HeaderDetailsRows, {
        detailsRenderConfig: detailsHeaderConfig,
        contentObject: contentObject
      }), /*#__PURE__*/_jsx(Button, {
        onClick: openDetailsPanel,
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "content-management-details-lib.header.headerDetails.openDetailsPanelButton"
        })
      })]
    })
  });
};
const HeaderDetailsLeftContent = ({
  contentObject,
  PreviewImage
}) => {
  const PreviewImageComponent = PreviewImage || ContentPreviewScreenshot;
  return /*#__PURE__*/_jsx(PreviewImageComponent, {
    contentObject: contentObject
  });
};
const HeaderDetails = ({
  contentObject,
  onChangeLanguageVariation,
  openDetailsPanel,
  PreviewImage
}) => {
  const {
    isCurrentlyViewingAllLangVariations
  } = useLanguageVariationsProvider();
  const {
    contentId
  } = useContentDetailsDataProvider();
  if (isCurrentlyViewingAllLangVariations) {
    return /*#__PURE__*/_jsx(LanguageTranslationSelector, {
      contentId: contentId,
      contentObject: contentObject,
      onChangeLanguageVariation: onChangeLanguageVariation
    });
  }
  return /*#__PURE__*/_jsx(FoundationsHeaderDetails, {
    leftContent: /*#__PURE__*/_jsx(HeaderDetailsLeftContent, {
      contentObject: contentObject,
      PreviewImage: PreviewImage
    }),
    rightContent: /*#__PURE__*/_jsx(View, {
      maxInlineSize: "33vw",
      children: /*#__PURE__*/_jsx(DescriptionList, {
        children: /*#__PURE__*/_jsx(HeaderDetailsList, {
          contentObject: contentObject,
          onChangeLanguageVariation: onChangeLanguageVariation,
          openDetailsPanel: openDetailsPanel
        })
      })
    })
  });
};
export default HeaderDetails;